


























































import { Component } from "vue-property-decorator";
import { ITravelAdditions } from "@/entities/travel/additions/travelAdditions";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ITravel } from "@/entities";
const ButtonCommon = () => import('@/components/lib/ButtonCommon.vue');
const GroupTravelModal = () => import('@/components/modal/GroupTravelModal.vue');
const EmailForm = () => import('@/components/contact/EmailForm.vue');

@Component({
  components: {
    ButtonCommon,
    GroupTravelModal,
    EmailForm,
  },
  filters: {
    capitalizeFirstSymbol: (str: string): string => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
})
export default class PaidGroupTravel extends Vue {
  dialog = false;

  get currentTravelFormat(): ITravel {
      return this.$store.getters.getGroupTravel.travel_format;
    }

  get getIsShowEmailFormActive() {
    return this.$store.getters.getEmailModalCondition;
  }

  private callModal(): void {
    // this.dialog = true;
    this.$store.dispatch('setEmailModalCondition', true);
  }

  get getGroupTravelAdditions(): ITravelAdditions {
    return this.$store.getters.getGroupTravelAdditions;
  }

  get bookingFields(): TranslateResult {
    return this.$t('groupTravelTabs.travelAdditionPayment.bookingFields');
  }

  get paidCondition(): TranslateResult {
    return this.$t('groupTravelTabs.travelAdditionPayment.paidCondition');
  }

  get cancelCondition(): TranslateResult {
    return this.$t('groupTravelTabs.travelAdditionPayment.cancelCondition');
  }

}
